module.exports = __webpack_public_path__ + "img/shape-1_gray-500.fc4f90c.png";